import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Select,
  MenuItem,
  Card,
  CardContent,
  Typography,
  Grid,
  InputLabel,
  FormControl,
} from "@mui/material";

const Admin = () => {
  const [clients, setClients] = useState([]);
  const [selectedDoctors, setSelectedDoctors] = useState({}); // { clientId: doctorId }

  // Sample doctors array
  const doctors = [
    { id: "d1", name: "Dr. Alice Smith", email: "cjfrancisf@gmail.com" },
    { id: "d2", name: "Dr. Bob Johnson", email: "bob@example.com" },
    { id: "d3", name: "Dr. Carol Lee", email: "carol@example.com" },
  ];

  // Fetch clients
  const fetchClients = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_BACKEND_URL+"/get-clients", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || null}`,
        },
      });
      setClients(res.data.clients || []);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  // Handle doctor selection for a client
  const handleDoctorChange = (clientId, doctorId) => {
    setSelectedDoctors((prev) => ({
      ...prev,
      [clientId]: doctorId,
    }));
  };

  // Assign doctor to client
  const assignDoctor = async (client) => {
    const doctorId = selectedDoctors[client._id];
    if (!doctorId) return;

    const doctor = doctors.find((d) => d.id === doctorId);

    try {
      await axios.post(process.env.REACT_APP_BACKEND_URL+"/assign-doctor", {
        clientId: client._id,
        assignedDoctor: doctor,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || null}`,
        },
      });

      alert(`Doctor ${doctor.name} assigned to ${client.name}`);
      fetchClients(); // Refresh clients
    } catch (error) {
      console.error("Error assigning doctor:", error);
      alert("Failed to assign doctor");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #e6f2e6, #c8e6c9)",
        padding: "2rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        style={{ color: "#2e7d32", fontWeight: "bold", marginBottom: "1.5rem" }}
      >
        Admin Panel - Assign Doctors
      </Typography>

      <Grid container spacing={3}>
        {clients.map((client) => (
          <Grid item xs={12} md={6} lg={4} key={client._id}>
            <Card
              style={{
                backgroundColor: "#f1f8f1",
                borderLeft: "6px solid #2e7d32",
                borderRadius: "12px",
              }}
            >
              <CardContent>
                <Typography variant="h6" style={{ color: "#1b5e20", fontWeight: "bold" }}>
                  {client.name}
                </Typography>

                <Typography variant="body2" color="textSecondary">
                  <strong>Email:</strong> {client.email}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Phone:</strong> {client.phoneNumber || "N/A"}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Age:</strong> {client.age || "N/A"}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Sex:</strong> {client.sex}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Chief Complaint:</strong> {client.chiefComplaint || "N/A"}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Last Visit:</strong>{" "}
                  {client.updatedAt ? new Date(client.updatedAt).toLocaleDateString() : "N/A"}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Assigned Doctor:</strong>{" "}
                  {client.assignedDoctor ? client.assignedDoctor.name : "None"}
                </Typography>

                {!client.assignedDoctor && (
                  <div style={{ marginTop: "1rem" }}>
                    <FormControl fullWidth>
                      <InputLabel id={`doctor-select-${client._id}`}>
                        Select Doctor
                      </InputLabel>
                      <Select
                        labelId={`doctor-select-${client._id}`}
                        value={selectedDoctors[client._id] || ""}
                        onChange={(e) =>
                          handleDoctorChange(client._id, e.target.value)
                        }
                      >
                        {doctors.map((doc) => (
                          <MenuItem value={doc.id} key={doc.id}>
                            {doc.name} ({doc.email})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Button
                      variant="contained"
                      style={{
                        marginTop: "0.8rem",
                        backgroundColor: "#2e7d32",
                        color: "#fff",
                      }}
                      onClick={() => assignDoctor(client)}
                      disabled={!selectedDoctors[client._id]}
                    >
                      Assign Doctor
                    </Button>
                  </div>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Admin;